/**
 * Owner: Masa Bayu
 * File: author-publish-readiness.ts
 * Date:Time: 2026-09-16 14:05
 * Description: T6-E2 publish readiness checklist — actionable; ≠ QXP editor.
 */
import { assertNoForbiddenFoundationKey } from './authority';
import { assertT6E2SecurityIntact } from './author-security';
export const QXREAD_PUBLISH_READINESS_ITEMS = [
    'title',
    'cover',
    'metadata',
    'qxp_ref_bound',
    'version_label',
];
/**
 * Evaluate publish readiness. Failures are actionable checklist items — not QXP edits.
 */
export function evaluatePublishReadiness(input) {
    assertNoForbiddenFoundationKey(input, 'QXRead publish readiness');
    assertT6E2SecurityIntact();
    const checklist = Object.freeze({
        title: input.hasTitle,
        cover: input.hasCover,
        metadata: input.hasMetadata,
        qxp_ref_bound: input.qxpRefBound,
        version_label: input.hasVersionLabel,
    });
    const missing = Object.freeze(QXREAD_PUBLISH_READINESS_ITEMS.filter((item) => !checklist[item]));
    return Object.freeze({
        ready: missing.length === 0,
        missing,
        checklist,
        mutatesQxp: false,
        mutatesQxw: false,
    });
}
//# sourceMappingURL=author-publish-readiness.js.map